import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import Collapse from 'components/basic/Collapse';
import Typograf from 'components/basic/Typograf';
import { H1 } from 'components/basic/Typography';
import { faqItems } from 'components/pagesComponents/landing/ForResearches/components/FAQ/constants';

import s from './FAQ.module.scss';

const FAQ: FC = () => {
  const leftCol = [];
  const rightCol = [];

  for (let i = 0; i < faqItems.length; i++) {
    const { header, content } = faqItems[i];
    const item = (
      <Collapse
        className={s.faqItem}
        key={header}
        header={header}
        content={content}
      />
    );

    if (i + 1 < faqItems.length / 2) {
      leftCol.push(item);
    } else {
      rightCol.push(item);
    }
  }

  return (
    <Typograf>
      <H1 className="text-center mb-sm-6 mb-xl-10">
        {/* @ts-ignore */}
        <a name="FAQ">FAQ</a>
      </H1>
      <div className={cn(s.faqItems, 'grid')}>
        <div className="g-col-lg-6 g-col-sm-12">{leftCol}</div>
        <div className="g-col-lg-6 g-col-sm-12">{rightCol}</div>
      </div>
    </Typograf>
  );
};

export default FAQ;
